const constants = {
    web_general: "Webchat non-GPT backup",
    voice_general: "Voice bot non-GPT backup",
    GEN_WEB: "Webchat non-GPT backup",
    GEN_VOICE: "Voice bot non-GPT backup",
    OUTBOUND: "Outbound",
    OUTBOUND_SMS: "Outbound SMS",
   
   
    // Twilio Official A2P 10DLC Use Case Values (API enum values)
    // Documentation: https://www.twilio.com/docs/messaging/compliance/a2p-10dlc/standard-use-cases
    USE_CASE_OPTIONS: [
      { key: '2fa', text: 'Two-Factor Authentication (2FA)', value: '2FA' },
      { key: 'account_notification', text: 'Account Notifications', value: 'ACCOUNT_NOTIFICATION' },
      { key: 'customer_care', text: 'Customer Care & Support', value: 'CUSTOMER_CARE' },
      { key: 'delivery_notification', text: 'Delivery Notifications', value: 'DELIVERY_NOTIFICATION' },
      { key: 'fraud_alert', text: 'Fraud Alert Messaging', value: 'FRAUD_ALERT' },
      { key: 'higher_education', text: 'Higher Education', value: 'HIGHER_EDUCATION' },
      { key: 'low_volume', text: 'Low Volume Mixed', value: 'LOW_VOLUME' },
      { key: 'marketing', text: 'Marketing', value: 'MARKETING' },
      { key: 'mixed', text: 'Mixed Use Case', value: 'MIXED' },
      { key: 'polling_voting', text: 'Polling and Voting', value: 'POLLING_VOTING' },
      { key: 'public_service_announcement', text: 'Public Service Announcements', value: 'PUBLIC_SERVICE_ANNOUNCEMENT' },
      { key: 'security_alert', text: 'Security Alerts', value: 'SECURITY_ALERT' },
    ],

  CONSENT_TYPE_OPTIONS: [
    { key: 'web_form_with_opt_in', text: 'Web form with opt-in', value: 'web_form_with_opt_in' },
    { key: 'sms_opt_in', text: 'SMS opt-in', value: 'sms_opt_in' },
    { key: 'prior_customer_relationship', text: 'Prior customer relationship', value: 'prior_customer_relationship' },
    { key: 'written_agreement', text: 'Written agreement', value: 'written_agreement' },
    { key: 'inquired_via_inbound_call', text: 'Inquired via inbound call', value: 'inquired_via_inbound_call' },
    { key: 'other', text: 'Other', value: 'other' }
  ] 


   };
   export default constants;
   
